// Canonical http/https URL detection used by chat embed resolution and by
// any place that needs to surface user-pasted links. Kept here (and not
// inlined in ChatService) so the markdown pipeline, the OGP resolver, the
// dev fixture, and any future "auto-linkify message" logic all share one
// definition — when the rule changes (TLD allow-list, IDN handling,
// schemeless URLs, …), it changes in one place.
//
// The regex matches anywhere in the text (no `^…$` anchors). The trailing-
// punctuation trim handles the common "URL at end of sentence" case where
// the regex would otherwise capture a `.` `,` `;` `:` `!` `?` `)` `]` `}`
// `'` `"` that is almost always sentence/quote punctuation, not part of
// the URL. The TLD/path char class avoids the same trailing punctuation in
// the first place; the trim is belt-and-suspenders.

export const URL_REGEX =
  /https?:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&/=]*/g;

const TRAILING_PUNCTUATION = /[.,;:!?)\]}'"]+$/;

const trimTrailing = (url: string): string => url.replace(TRAILING_PUNCTUATION, '');

export function extractFirstUrl(text: string): string | null {
  // `matchAll` returns an iterator so we don't allocate a full match list
  // when the first hit is all we need.
  const iter = text.matchAll(URL_REGEX);
  const first = iter.next();
  return first.done ? null : trimTrailing(first.value[0]);
}

export function extractAllUrls(text: string): string[] {
  const matches = text.match(URL_REGEX);
  return matches ? matches.map(trimTrailing) : [];
}
